import React from 'react';
import {authRoles} from 'app/auth';

export const HSSEDashboardAppConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/apps/dashboards/hsse',
            component: React.lazy(() => import('./HSSEDashboardApp'))
        }, 
        {
            path     : '/',
            exact    : true,
            component: React.lazy(() => import('./HSSEDashboardApp'))
        }, 
        {
            path     : '/summary',
            component: React.lazy(() => import('./HSSEDashboardApp'))
        },
        {
            path     : '/reports/:reportId',
            auth     : authRoles.admin,
            component: React.lazy(() => import('../../reports-app/ReportsApp'))
        },
        {
            path     : '/reports',
            exact    : true,
            auth     : authRoles.admin,
            component: React.lazy(() => import('./HSSEDashboardApp'))
        }

    ]
};
